export const setDroneFilterTypes = filterName => ({
  type: 'SET_DRONE_FILTER_TYPES',
  payload: filterName,
});
